var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.561,
    height: 20.614,
    viewBox: "0 0 20.561 20.614",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sign-out-alt_1_",
    "data-name": "sign-out-alt (1)",
    transform: "translate(0.15 0.15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38570",
    "data-name": "Path 38570",
    d: "M9.714,12.7a.846.846,0,0,0-.846.846v2.539a2.539,2.539,0,0,1-2.539,2.539h-2.1a2.539,2.539,0,0,1-2.539-2.539V4.232A2.539,2.539,0,0,1,4.232,1.693h2.1A2.539,2.539,0,0,1,8.867,4.232V6.771a.846.846,0,1,0,1.693,0V4.232A4.237,4.237,0,0,0,6.328,0h-2.1A4.237,4.237,0,0,0,0,4.232v11.85a4.237,4.237,0,0,0,4.232,4.232h2.1a4.237,4.237,0,0,0,4.232-4.232V13.543A.846.846,0,0,0,9.714,12.7Z",
    stroke: "#fff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38571",
    "data-name": "Path 38571",
    d: "M20.123,9.13,16.242,5.248a.846.846,0,1,0-1.2,1.2l3.608,3.608-12.806.025a.846.846,0,0,0,0,1.693h0L18.7,11.745l-3.659,3.66a.846.846,0,1,0,1.2,1.2l3.882-3.882a2.539,2.539,0,0,0,0-3.591Z",
    transform: "translate(-0.768 -0.768)",
    stroke: "#fff",
    strokeWidth: 0.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout_icon.b5b82ee1558983c0f5233b780ee8ef53.svg";
export { ForwardRef as ReactComponent };